import React, { useState } from 'react';
import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  useIonViewWillEnter
} from '@ionic/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperCore } from 'swiper';
import { arrowForward } from 'ionicons/icons';
import { setMenuEnabled } from '../data/sessions/sessions.actions';
import { setHasSeenTutorial } from '../data/user/user.actions';
import { connect } from '../data/connect';
import { RouteComponentProps, withRouter } from 'react-router';
import { Storage } from '@capacitor/storage';
import { useTutorial } from '../hooks/useTutorial';
import { getAppConfig } from '../config/app.config';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './Tutorial.scss';

interface OwnProps extends RouteComponentProps {}

interface DispatchProps {
  setHasSeenTutorial: typeof setHasSeenTutorial;
  setMenuEnabled: typeof setMenuEnabled;
}

interface TutorialProps extends OwnProps, DispatchProps {}

let swiper: SwiperCore | undefined;

const Tutorial: React.FC<TutorialProps> = ({ history, setHasSeenTutorial, setMenuEnabled }) => {
  const [showSkip, setShowSkip] = useState(true);
  const [backgroundPos, setBackgroundPos] = useState(0);

  // Hook para manejar el tutorial
  const { markTutorialAsSeen } = useTutorial();

  useIonViewWillEnter(() => {
    setMenuEnabled(false);
  });

  // Función modificada startApp:
  // Verifica si la sesión ya fue iniciada consultando Storage.
  // Si está iniciada, redirige a schedule; de lo contrario, redirige a login.
  const startApp = async () => {
    try {
      // Marcar tutorial como visto usando el hook
      await markTutorialAsSeen();

      // También actualizar el estado Redux para compatibilidad
      await setHasSeenTutorial(true);
      await setMenuEnabled(true);

      // Verificar si el usuario ya está logueado
      const { value: hasLoggedIn } = await Storage.get({ key: 'hasLoggedIn' });
      if (hasLoggedIn === 'true') {
        const defaultRoute = getAppConfig().auth.defaultRoute || '/tabs/schedule';
        history.push(defaultRoute, { direction: 'none' });
      } else {
        history.push('/login', { direction: 'none' });
      }
    } catch (error) {
      console.error('Error al completar tutorial:', error);
      // En caso de error, continuar con la navegación
      history.push('/login', { direction: 'none' });
    }
  };

  const handleSlideChangeStart = () => {
    if (!swiper) return;
    setShowSkip(!swiper.isEnd);
    setBackgroundPos(swiper.realIndex);
  };

  return (
    <IonPage id="tutorial-page">
      <IonHeader no-border className="transparent">
        <IonToolbar>
          <IonButtons slot="end">
            {showSkip && <IonButton color="primary" onClick={startApp}>Saltar</IonButton>}
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent style={{ backgroundPositionX: backgroundPos * 20 + "%" }} fullscreen>
        <Swiper onSwiper={s => { swiper = s; }} spaceBetween={50} onSlideChangeTransitionStart={handleSlideChangeStart}>
          <SwiperSlide>
            <img src="assets/img/ica-slidebox-img-1.png" alt="" className="slide-image" />
            <h2 className="slide-title">
              <b><p>Bienvenido a la app de la</p></b>Asociación Panameña de Ingenieros Industriales
            </h2>
            <p>
              Aquí podrá ver su carnet digital, información de eventos y otra información importante.
            </p>
          </SwiperSlide>
          <SwiperSlide>
            <img src="assets/img/ica-slidebox-img-2.png" alt="" className="slide-image" />
            <h2 className="slide-title">Añada al calendario</h2>
            <p>
              Las sesiones y actividades que más le llamen la atención.
            </p>
          </SwiperSlide>
          <SwiperSlide>
            <img src="assets/img/ica-slidebox-img-3.png" alt="" className="slide-image" />
            <h2 className="slide-title">Preguntas</h2>
            <p>
              Recuerde votar o realizar sus preguntas en las sesiones y actividades.
            </p>
          </SwiperSlide>
          <SwiperSlide>
            <img src="assets/img/ica-slidebox-img-4.png" alt="" className="slide-image" />
            <h2 className="slide-title">Bienvenido(a)</h2>
            <IonButton fill="clear" onClick={startApp}>
              Continuar
              <IonIcon slot="end" icon={arrowForward} />
            </IonButton>
          </SwiperSlide>
        </Swiper>
      </IonContent>
    </IonPage>
  );
};

export default connect<OwnProps, {}, DispatchProps>({
  mapDispatchToProps: {
    setHasSeenTutorial,
    setMenuEnabled
  },
  component: withRouter(Tutorial)
});
